import { type FeatureModule } from '@store/features/types';

export const transcriptionFeature: FeatureModule = {
  id: 'transcription',
  name: 'Transcription',
  dependencies: [],
  reducers: {},
  middleware: [],
  persistence: { enabled: false },
  sync: { enabled: false },
  setup: _store => {},
  cleanup: _store => {},
};
